import React from "react"
import RegisterForm from "components/organisms/RegisterForm"

function RegisterPage() {
  return (
    <RegisterForm/>
  )
}

export default RegisterPage
